import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { Book, BookTypeNameEnum } from '~/api/book/bookApiTypes';
import { CycleLink } from '~/atomic/atom/links/dynamicLinks';
import { BookReaderThemeEnum } from '~/atomic/page/book-reader/reader.slice';
import { TextRegStyle } from '~/atomic/Typography';
import { defaultCycleName } from '~/feature/cycle/cycleSlice';
import { GraphqlBook } from '~/graphql/books/factory/book/BookFactoryTypes';
import { lessThan } from '~/lib/mediaQuery';

export interface BookCycleProps extends HTMLAttributes<HTMLDivElement> {
  theme?: BookReaderThemeEnum;
  book: Book | Partial<GraphqlBook>;
}

export const BookCycle = ({
  theme = BookReaderThemeEnum.Light, book, ...props
}: BookCycleProps) => {
  const isDefaultCycle = (book?.cycle?.name ?? '') === defaultCycleName;
  const author = 'authors' in book ? book?.authors?.[0] : book?.author;

  if (isDefaultCycle) {
    return (
      <SCBookCycle
        data-theme={theme}
        {...props}
      >
        <SCCycleText>
          {BookTypeNameEnum[book.type] ?? ''}
        </SCCycleText>
      </SCBookCycle>
    );
  }

  return (
    <SCBookCycle
      data-theme={theme}
      {...props}
    >
      <SCCycleText>
        {`${BookTypeNameEnum[book.type] ?? 'Произведение'} из`}
        <CycleLink
          authorUsername={author?.username ?? ''}
          slug={book.cycle?.slug ?? ''}
        >
          <SCCycleName>
            серии
            {' '}
            {book.cycle?.name ?? ''}
          </SCCycleName>
        </CycleLink>
        <SCCycleNumber itemProp="position">
          {` #${book.cycle?.numInCycle ?? ''}`}
        </SCCycleNumber>
      </SCCycleText>
    </SCBookCycle>
  );
};

const SCCycleName = styled.a`
  ${TextRegStyle};
  color: var(--gray-color);
  transition: 0.3s;
  margin-left: 4px;
`;

const SCCycleText = styled.span`
  ${TextRegStyle};
  color: var(--black-color);
  transition: 0.3s;
`;

const SCCycleNumber = styled.span``;

const SCBookCycle = styled.div`
  margin-bottom: 10px;

  &[data-theme=${BookReaderThemeEnum.Dark}] {
    color: var(--white-color);
    
    ${SCCycleText} {
      color: var(--white-color);
    }

    ${SCCycleName} {
      color: var(--white-color);
    }
  }

  ${lessThan('sm')} {
    width: 100%;
  }
`;
